/**
 * Uplifted verbatim from apps/web/src/redux-store/slices/KeyBoardShortcuts.ts, which was
 * byte-identical to apps/mobile/src/reduxStore/slices/KeyBoardShortcuts.ts.
 *
 * The platforms do not differ, so `shared.ts` owns the WHOLE slice and the two platform
 * files are re-exports. Do not "balance" this by copying `createSlice` into both platform
 * files — `initialState` and `reducers` are constructor arguments, so a split-but-identical
 * slice means two complete copies kept in sync by hand, which is the drift this package
 * exists to stop (plan §9). Promote to real platform files only on genuine divergence.
 */
import { createSlice } from "@reduxjs/toolkit";

export interface BusinessState {
  currentShortcutPressed: string;
}

const initialState: BusinessState = {
  currentShortcutPressed: "",
};

export const keyboardShortcutSlice = createSlice({
  name: "keyboardShortcut",
  initialState,
  reducers: {
    updateCurrentShortcut: (state, action) => {
      // Preserved, not fixed: this logs on every shortcut keypress. Removing it is a
      // behaviour change and belongs in its own ticket, not the uplift.
      console.log("!!!!!!!!!!!!!!!", action);
      state.currentShortcutPressed = action.payload;
    },
    resetCurrentShortcut: (state) => {
      state.currentShortcutPressed = "";
    }
  },
});

export const {
  updateCurrentShortcut,
  resetCurrentShortcut,
} = keyboardShortcutSlice.actions;
export default keyboardShortcutSlice.reducer;
